/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-dispatch': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#6ca2ca"><path pid="0" d="M18.36 18.94V6.156L9.93 1.084 1.5 6.155v4.814a.5.5 0 1 1-1 0V5.872a.5.5 0 0 1 .242-.428L9.672.072a.5.5 0 0 1 .516 0l8.93 5.372a.5.5 0 0 1 .243.428v13.569a.5.5 0 0 1-.5.5H1a.5.5 0 0 1 0-1z"/><path pid="1" d="M11.742 11.011l-3.306 2.766a.5.5 0 1 0 .642.767l3.767-3.152a.5.5 0 0 0-.003-.77L9.075 7.518a.5.5 0 1 0-.636.772z"/></g>'
  }
})
